import client from "./client";

// Public (unauthenticated) password recovery + invitation acceptance calls.
export const forgotPassword = (email) => client.post("/auth/forgot-password", { email });

export const checkToken = (mode, token) =>
  client.get(mode === "invite" ? `/auth/invite/${token}` : `/auth/reset-password/${token}`);

export const submitPassword = (mode, token, password) =>
  client.post(mode === "invite" ? "/auth/invite/accept" : "/auth/reset-password", { token, password });
